<template lang="pug">
//- span {{userList}}
#usersContent
  .tag-list(v-for="(type,index) in showlist" :key="index")
    .tag-block(v-if="type.array.length>0")
      .name {{type.label}}:
      .tag-con
        el-tag(v-for="(user, index) in type.array" size="small" @close="deleteUser(user)"
          closable :key="index" :title="user.name || user.userName")
          el-image(:src="circleUrl(user)" v-if="user.selectCode==='User'")
            .userAvatar(slot="error") {{userName(user.selectName||user.name||user.userName)}}
          node-icon(:type="user.selectCode" v-else)
          span {{ user?.selectName || user?.name || user.userName}}
</template>

<script>
import { gettouxAvatar } from "@/CommonDP/utils";
import NodeIcon from "./component/NodeIcon.vue";
import cloneDeep from "lodash/cloneDeep";
import { ALL_NAV_LIST } from "./leftCom";
export default {
  components: { NodeIcon },
  props: {
    userList: {
      type: Array,
      default: () => []
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      roleIcon: require("@/CommonDP/assets/doc/role.png")
    };
  },
  computed: {
    showlist() {
      const list = cloneDeep(ALL_NAV_LIST);
      return list.map((e) => {
        return {
          ...e,
          array: this.userList?.filter((user) => user.selectCode === e.code) || []
        };
      });
    }
  },
  methods: {
    circleUrl(item) {
      const avatatDescribe = {
        "User": () => {
          return gettouxAvatar(item.userId);
        },
        "SystemRole": () => {
          return require("@/CommonDP/assets/doc/role.png");
        },
        "SpecRole": () => {
          return require("@/CommonDP/assets/doc/role.png");
        },
        "PrjRole": () => {
          return require("@/CommonDP/assets/doc/role.png");
        },
        "Label": () => {
          return require("@/CommonDP/assets/org/tag.png");
        },
        "Dept": () => {
          return require('@/CommonDP/assets/doc/folderChild.png');
        }
      };
      const selectCode = item.selectCode || "User";
      return avatatDescribe[selectCode] ? avatatDescribe[selectCode]() : "";
    },
    errorHandler() {
      return true;
    },
    deleteUser(user) {
      if (this.disabled) { return; }
      this.$confirm(`确认${this.deleteToolTip(user)}:${user.name || user.selectName || user.userName}?`, {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        customClass: "el-message-box"
      }).then(async () => {
        this.$emit("deleteUser", user);
      }).catch(() => {
        // this.$message.info("已取消");
      });
    },
    deleteToolTip(user) {
      const tipDescribe = {
        "User": () => { return "删除人员"; },
        "SystemRole": () => { return "删除系统角色"; },
        "SpecRole": () => { return "删除专业角色"; },
        "PrjRole": () => { return "删除项目角色"; },
        "Label": () => { return "删除标签"; },
        "Dept": () => { return "删除部门"; }
      };
      return tipDescribe[user.selectCode] ? tipDescribe[user.selectCode]() : "删除";
    },
    userName(val) {
      return val?.charAt?.(0) || "";
    }
  }

};
</script>

<style lang="scss" scoped>
#usersContent{
  width: 100%;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
  max-height: 170px;
  .tag-block{
    line-height: 1.2;
    display: flex;
    justify-content: flex-start;
    .name{
      width: 55px;
      line-height: 35px;
      flex-shrink: 0;
    }
    .tag-con{
      padding: 5px 10px;
      display: flex;
      flex-direction: row;
      flex-wrap:wrap;
      align-items: center;
      border-radius: 5px;
      .el-tag{
        display: flex;
        flex-direction: row;
        align-items: center;
        margin-right: 5px;
        margin-bottom: 10px;
        /deep/.el-icon-close{
          top: 2px;
        }
      }
      .el-image{
        width: 16px;
        height: 16px;
        margin-right: 5px;
        border-radius: 5px;
        object-fit: contain;
        flex-shrink: 0;
      }
      .node-icon{
        /deep/img{
          width: 16px;
          height: 16px;
          object-fit: scale-down;
          flex-shrink: 0;
        }
      }
    }
  }
}
// #usersContent{
//   width: calc(100% - 10px);
//   max-height: 170px;
//   overflow-y: auto;
//   display: flex;
//   flex-direction: column;
//   .users{
//     padding: 5px 10px;
//     height: 35px;
//     display: flex;
//     flex-direction: row;
//     align-items: center;
//     border-radius: 5px;
//     .el-image{
//       width: 20px;
//       height: 20px;
//       border-radius: 5px;
//       object-fit: contain;
//     }
//     /deep/.userAvatar{
//       line-height: 20px;
//       font-size: 12px;
//       border-radius: 5px;
//       text-align: center;
//       background-color: #409eff;
//       color: #fff;
//     }
//     .name{
//       margin-left: 5px;
//       font-size: 12px;
//       line-height: 28px;
//     }
//     i{
//       margin-left: 5px;
//       font-size: 14px;
//       line-height: 28px;
//       color: rgb(214, 10, 10);
//       cursor: pointer;
//     }
//     .noClick{
//       cursor: not-allowed;
//     }
//   }
//   .users:hover{
//     background-color: #ebeef5;
//   }

// }
</style>
